import React, { useState, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { BreadcrumbProvider } from '../context/BreadcrumbContext';
import Sidebar from './Sidebar';
import Header from './Header';

// Mapa ruta → label amigable para el widget "Accesos recientes" del Home.
const ROUTE_LABELS = {
  '/home': 'Inicio',
  '/dashboard': 'Dashboard (Postventa)',
  '/proyectos': 'Proyectos',
  '/proveedores': 'Proveedores',
  '/hitos': 'Hitos',
  '/chatbot-comercial': 'Chatbot Comercial',
  '/plugin/experiencia-adendas': 'Adendas Acumulativas',
  '/auditoria': 'Auditoría',
  '/usuarios': 'Usuarios',
  '/roles': 'Roles',
  '/menus': 'Menús',
  '/parametros': 'Parámetros',
  '/integraciones': 'Integraciones',
  '/plugins': 'Plugins',
  '/perfil': 'Mi perfil',
  '/notificaciones': 'Notificaciones',
  '/configuracion-general': 'Configuración general',
};

const RECENT_KEY = 'ibc_recent_paths';
const RECENT_MAX = 5;

const trackRecent = (pathname) => {
  // Solo trackeamos rutas del catálogo. Ignoramos home (es donde se muestra) y rutas dinámicas no listadas.
  if (pathname === '/home' || !ROUTE_LABELS[pathname]) return;
  try {
    const raw = localStorage.getItem(RECENT_KEY);
    const prev = raw ? JSON.parse(raw) : [];
    const filtered = prev.filter(r => r.path !== pathname);
    const next = [{ path: pathname, label: ROUTE_LABELS[pathname], ts: Date.now() }, ...filtered].slice(0, RECENT_MAX);
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch { /* localStorage lleno o deshabilitado, ignorar */ }
};

const DashboardLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) trackRecent(location.pathname);
  }, [location.pathname, isAuthenticated]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#9d8272] mx-auto"></div>
          <p className="mt-4 text-[#5A5A5A]">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <BreadcrumbProvider>
      <div className="flex h-screen bg-[#F5F5F5]">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="flex-1 flex flex-col overflow-hidden min-w-0">
          <Header onMenuToggle={() => setSidebarOpen(true)} />
          <main className="flex-1 overflow-y-auto p-3 sm:p-4 lg:p-6 xl:p-8">
            <Outlet />
          </main>
        </div>
      </div>
    </BreadcrumbProvider>
  );
};

export default DashboardLayout;
